export class LRU<K, V> {
  private map = new Map<K, V>();
  constructor(private capacity = 100) {}
  get(key: K): V | undefined {
    if (!this.map.has(key)) return undefined;
    const v = this.map.get(key)!; this.map.delete(key); this.map.set(key, v);
    return v;
  }
  set(key: K, val: V) {
    if (this.map.has(key)) this.map.delete(key);
    this.map.set(key, val);
    if (this.map.size > this.capacity) {
      const k = this.map.keys().next().value as K;
      this.map.delete(k);
    }
  }
}
